function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as activityListApi from '@/api/activityListApi.js';
import { Debounce } from '@/utils/validate';
export default {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {
        image: null
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    openInit: function openInit(row) {
      this.pram = _objectSpread({}, row);
      this.visible = true;
    },
    handerSubmit: Debounce(function (form) {
      var _this = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this.loading = true;
        activityListApi[_this.pram.id ? 'UpdateArticle' : 'AddArticle'](_this.pram).then(function (data) {
          _this.$message.success('操作成功');
          _this.loading = false;
          _this.visible = false;
          _this.$emit('doRefresh');
        }).catch(function () {
          _this.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    //上传图片
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this2 = this;
      this.$modalUpload(function (img) {
        _this2.$set(_this2.pram, dataIndex, img[0].sattDir);
      }, tit, 'system');
    },
    removeImg: function removeImg(dataIndex) {
      this.$set(this.pram, dataIndex, '');
    }
  }
};